import styled from 'styled-components';

export const Title = styled.div`
    font-size: 18px;
    font-weight: 700;
    color: ${props => props.theme.colors.primary}
    margin-bottom: 1rem;
`
export const SubTitle = styled.div`
    font-size: 14px;
    font-weight: 700;
    color: ${props => props.theme.colors.textBold}
`
